import React from "react";
import { FlexColumn } from "@/ui/FlexContainer/FlexContainer";
import Typography from "@/ui/Typography/Typography";
import Button from "@/ui/Button/Button";
import { TgLogoIcon, CloseIcon } from "@/assets/icons";
import Img from "@/assets/advice.png";
import { sendFiveWays } from "@/api/base";
import { useUserInfoStore } from "@/store/userInfoStore";
import cls from "./styles.module.scss";

export const AdviceBlock = ({ canClose = true }: { canClose: boolean }) => {
  const { yandexId } = useUserInfoStore.getState();
  const serviceType = useUserInfoStore((s) => s.serviceType);
  const isAdviceBannerOpen = useUserInfoStore((s) => s.isAdviceBannerOpen);
  const setIsAdviceBannerOpen = useUserInfoStore(
    (s) => s.setIsAdviceBannerOpen
  );

  const handleClick = async () => {
    try {
      await sendFiveWays(yandexId);
    } catch (e) {
      console.log(e);
    }
  };

  if (serviceType !== "eats") return null;

  return (
    (isAdviceBannerOpen || !canClose) && (
      <FlexColumn gap={12} className={cls.wrapper}>
        {canClose && (
          <button
            type="button"
            className={cls.closeBtn}
            onClick={() => setIsAdviceBannerOpen(false)}
          >
            <CloseIcon />
          </button>
        )}
        <div className={cls.yellowCircle} />
        <div className={cls.imgBlock}>
          <img src={Img} alt="advice" />
        </div>

        <Typography className={cls.label}>Кажется, звать некого?</Typography>
        <Typography className={cls.desc}>
          Так думали и те,
          <br />
          кто уже привёл пятерых
        </Typography>

        <Button
          label="Забрать топ-5 способов"
          icon={<TgLogoIcon />}
          className={cls.btn}
          onClick={handleClick}
        />
      </FlexColumn>
    )
  );
};
